import BaseBlock from "./BaseBlock";
import EqualHeightPostCardCollection from "@/ts/base/Components/EqualHeightPostCardCollection";

class RecentPosts extends BaseBlock {

	protected collection!: EqualHeightPostCardCollection;
	protected cards!: NodeListOf<HTMLElement>;

	public init(): void {
		this.collection = new EqualHeightPostCardCollection(this.block, true);
		this.cards = this.block.querySelectorAll(this.collection.getSelector());

		if (this.isAnimated) {
			this.delayHeightEqualization();
		}
		else {
			this.collection.run();
		}
	}

	protected delayHeightEqualization(): void {
		setTimeout(() => {
			this.collection.run();
		}, this.cards.length * 300);
	}
}

export default RecentPosts;
